import { PerformanceTrackingKeys } from "../../../../../react/core/constants/constants";

import loadingButtonViewTemplate from "./LoadingButtonViewTemplate";

const LoadingButton = angular
    .module("LoadingButton", [])
    .directive("pwLoadingButton", [loadingButtonDirective]);

function loadingButtonDirective() {
    return {
        restrict: "E",
        replace: true,
        scope: {
            action: "&",
            disabledNotLoading: "=?",
            disabledLoading: "=?"
        },
        template: loadingButtonViewTemplate,
        compile: function (elem, attr) {
            return {
                pre: function (scope, elem, attrs) {
                    scope.buttonLoadingDisabled = false;
                    scope.defaultText = attrs.defaultText ? attrs.defaultText : "Submit";
                    scope.processingText = attrs.processingText
                        ? attrs.processingText
                        : "Processing...";
                    scope.allClasses =
                        "pw-loader btn btn-primary text-center " + attrs.loadingButtonClass;
                    scope.id = attrs.id ? attrs.id : null;
                },
                post: function (scope) {
                    scope.isDisabledLoading = function () {
                        return scope.disabledLoading !== undefined
                            ? scope.disabledLoading
                            : scope.buttonLoadingDisabled;
                    };

                    scope.isDisabled = function () {
                        return scope.disabledNotLoading || scope.isDisabledLoading();
                    };

                    scope.submitFunction = function ($event) {
                        scope.buttonLoadingDisabled = true;
                        scope.action.call(null, { $event: $event });
                        localStorage.setItem(
                            PerformanceTrackingKeys.PT_SIGNIN_CLICKED,
                            new Date().getTime()
                        );
                        localStorage.setItem(PerformanceTrackingKeys.PT_FIRST_LOAD, true);
                        localStorage.setItem(PerformanceTrackingKeys.PT_SIDEBAR_FIRST_LOAD, true);
                    };

                    if (scope.id !== null) {
                        scope.$on("reset-loading-button-" + scope.id, function (event, args) {
                            scope.buttonLoadingDisabled = false;
                        });
                    }
                }
            };
        }
    };
}

export default LoadingButton;
